"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function StudioPostsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="222486" className="flex space-x-6 px-4 md:px-8">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="w-[320px] md:w-[720px] h-[320px] shrink-0 bg-muted/10 animate-pulse border border-border rounded-lg" />)}
      </div>;
  }
  if (error) {
    return <div className="px-4 md:px-8 py-12 text-destructive font-sans text-sm">
        <p>Unable to load the latest recipes.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="px-4 md:px-8 py-12 text-muted-foreground font-sans text-sm">
        <p>No automation recipes found at the moment.</p>
      </div>;
  }
  return <ScrollArea className="w-full whitespace-nowrap pb-12">
      <div className="flex w-max space-x-6 px-4 md:px-8">
        {posts.map((post, i) => <article key={post.id} data-index={i} className="group relative flex h-[320px] w-[320px] shrink-0 flex-col overflow-hidden border-none bg-card shadow-md transition-all duration-500 hover:shadow-xl hover:-translate-y-1 md:w-[720px] md:flex-row rounded-lg">
            {}
            <div className="flex h-1/2 w-full flex-col justify-between border-b border-border bg-card p-6 md:h-full md:w-1/2 md:border-r md:border-b-0 md:p-8">
              <div className="space-y-2">
                <span className="inline-block px-3 py-1 rounded-full bg-accent text-[10px] font-bold uppercase tracking-widest text-primary">
                  Recipe
                </span>
                <h3 className="font-serif text-[28px] font-medium leading-[1.1] tracking-tight text-foreground transition-colors duration-300 md:text-[42px] whitespace-normal break-words line-clamp-4" onMouseEnter={e => {
              e.currentTarget.style.color = "var(--color-primary)";
            }} onMouseLeave={e => {
              e.currentTarget.style.color = "var(--color-foreground)";
            }}>
                  {post.title}
                </h3>
              </div>

              <div className="mt-4 flex items-end justify-between md:mt-auto">
                <span className="font-sans text-xs text-muted-foreground uppercase tracking-widest">
                  {post.date ? new Date(post.date).toLocaleDateString() : "HomeKit Guide"}
                </span>
                <Link to={post.link || "#"}>
                  <Button variant="outline" className="border-primary bg-transparent text-primary hover:bg-primary hover:text-primary-foreground rounded-full transition-all duration-300 group-hover:translate-x-1">
                    Read Guide →
                  </Button>
                </Link>
              </div>
            </div>

            {}
            <div className="relative h-1/2 w-full bg-muted md:h-full md:w-1/2">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-all duration-700 group-hover:scale-110" /> : <div className="h-full w-full bg-muted-foreground/5" />}
              <div className="pointer-events-none absolute inset-0 mix-blend-soft-light opacity-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/minimal_texture.png)] bg-repeat"></div>
            </div>
          </article>)}
      </div>
      <ScrollBar orientation="horizontal" className="bg-border/30" />
    </ScrollArea>;
}
export default function LiveFromTheStudio() {
  const wp_query_params = {
    post_type: "post",
    per_page: 6,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="latest-automation-recipes" className="bg-background text-foreground py-24 overflow-hidden">
      <div className="mb-12 px-4 md:px-8">
        <h2 className="font-default text-4xl font-bold tracking-tighter md:text-6xl">
          Latest Automation <span className="text-primary italic font-serif font-normal">Recipes</span>
        </h2>
        <p className="mt-4 max-w-2xl font-default text-lg text-muted-foreground leading-relaxed">
          Curated guides for a simpler life. Discover how to blend Apple HomeKit 
          seamlessly into your daily rituals with our editorial-style tutorials.
        </p>
      </div>

      <PostsProvider wp_query={{
      post_type: "post",
      per_page: 6,
      orderby: "date",
      order: "desc"
    }}>
        <StudioPostsConsumer />
      </PostsProvider>
    </section>;
}